import * as React from 'react';
import { Translate } from '../../../../../shared/LanguageService';
import { Button, ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Dropzone from '../../../../../components/common/Dropzone';

interface IBlueprintFileProps {
    thumbnailReference: string;
    hasAnnotation: boolean;
    createdByAdmin: boolean;
    onAnnotate: () => void;
    onDelete: () => void;
    onClick: () => void;
    showBlueprint: boolean;
    onShowBlueprint: () => void;
    isLocked: boolean;
    actionUrl: string;
    upload: boolean;
    onUploadCompleted: () => void;
    onFileUploadCompleted: (response: any) => void;
    onUpload: () => void;
    dropzoneId: string;
    originalCreatedByRole?: string;
}

const BlueprintFile = (props: IBlueprintFileProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <fieldset>
            <legend>
                {props.hasAnnotation
                    ? props.createdByAdmin === true
                        ? Translate('order/plan/storey/annotation-by-admin')
                        : Translate('order/plan/storey/annotation-by-customer')
                    : Translate('order/plan/storey/blueprint')}
            </legend>
            {props.thumbnailReference && (
                <div className="button-bar-below">
                    <div className="content-row">
                        <img
                            src={`${apiUrl}/file/${props.thumbnailReference}`}
                            onClick={props.onClick}
                            title={
                                props.originalCreatedByRole
                                    ? Translate('order/plan/storey/blueprint/title', {
                                          role: Translate(props.originalCreatedByRole)
                                      })
                                    : null
                            }
                        />
                    </div>
                    <div className="button-row">
                        {!props.isLocked && (
                            <ButtonGroup bsSize="sm">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-annotate">
                                            <p>{Translate('order/plan/storey/annotate-button')}</p>
                                        </Tooltip>
                                    }
                                >
                                    <Button bsStyle="info" onClick={props.onAnnotate}>
                                        <i className="material-icons no-label">mode_edit</i>
                                    </Button>
                                </OverlayTrigger>

                                {props.showBlueprint && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-show-blueprint">
                                                <p>
                                                    {Translate(
                                                        'order/plan/storey/blueprint-button'
                                                    )}
                                                </p>
                                            </Tooltip>
                                        }
                                    >
                                        <Button bsStyle="primary" onClick={props.onShowBlueprint}>
                                            <i className="material-icons no-label">
                                                photo_size_select_actual
                                            </i>
                                        </Button>
                                    </OverlayTrigger>
                                )}
                            </ButtonGroup>
                        )}
                    </div>
                </div>
            )}
            {!props.thumbnailReference && (
                <div className="button-bar-below">
                    <div className="content-row">
                        <Dropzone
                            dropzoneHtmlId={props.dropzoneId}
                            actionUrl={props.actionUrl}
                            upload={props.upload}
                            onUploadCompleted={props.onUploadCompleted}
                            onFileUploadCompleted={props.onFileUploadCompleted}
                            uploadMultiple={false}
                            maxFiles={1}
                            removeFileAfterSuccess={true}
                            acceptedFiles={'image/jpeg,image/png,image/gif,application/pdf'}
                        ></Dropzone>
                    </div>
                    <div className="button-row">
                        <ButtonGroup bsSize="sm">
                            <Button bsStyle="info" onClick={props.onUpload}>
                                <i className="material-icons">cloud_upload</i>{' '}
                                {Translate('order/plan/upload-button')}
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            )}
        </fieldset>
    );
};

export default BlueprintFile;
